// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__RFkKZ","options":"AnswerScale_options__1Bbe9","selected":"AnswerScale_selected__1W-d6"};